<span class="font-medium-title-large">
  Kontakt zum Mitgliederbereich "{{ areaName }}"
</span>

<form [formGroup]="form" class="align-self-stretch flex-c gap-16">
  <div class="input-simple align-self-stretch">
    <div class="input-label-wrapper">
      <label for="message" class="input-label"> Deine Nachricht* </label>
      <div class="input-label-hint">
        {{ form.controls['message'].value?.length || 0 }} / 1200
      </div>
    </div>
    <textarea
      id="message"
      name="message"
      class="input-textarea"
      rows="6"
      formControlName="message"
      placeholder="Schreibe hier deine Nachricht an den Ansprechpartner..."></textarea>
  </div>
</form>

<div class="flex-r gap-16 justify-center padding-top-16">
  <button
    type="button"
    class="inwi-icon-text-button-large-secondary"
    (click)="onCancel()">
    <div class="button-content">
      <i class="fa-regular fa-times button-icon"></i>
      <div class="button-text">Abbrechen</div>
    </div>
  </button>

  <button
    type="button"
    class="inwi-icon-text-button-large-primary"
    (click)="onSend()">
    <div class="button-content">
      <i class="fa-regular fa-paper-plane button-icon"></i>
      <div class="button-text">Nachricht senden</div>
    </div>
  </button>
</div>
